enum INodesType {
  'soft-node' = 'Soft Node',
  dtm = 'Dor Traffic Miner',
  'testnet-validator' = 'Testnet Validator',
}

export { INodesType }
